export default [
  {
    path: '/excel',
    name: 'excel',
    component: () =>
      import(/* webpackChunkName: "demo" */ '@/viewsTest/ExcelParseTest.vue'),
  },
  {
    path: '/form',
    name: 'form',
    component: () =>
      import(/* webpackChunkName: "form" */ '@/viewsTest/FormTest.vue'),
  },
  {
    path: '/demo',
    name: 'demo',
    component: () =>
      import(/* webpackChunkName: "demo" */ '@/viewsTest/Demo.vue'),
    meta: {
      theme: 'light', // eg: light/dark => 白/黑，默认为 light
      header: {
        // 头部配置
        visible: true, // eg: true/false => 展示/隐藏，默认为 true。sidebar、footer 同理
        userVisible: true, // 用户信息显隐配置。eg: true/false => 展示/隐藏，默认为 true。
      },
    },
  },
];
